import Vue from 'vue';
import GlobalMixin from './global';

export const mixins = [GlobalMixin];

mixins.forEach((mixin) => Vue.mixin(mixin));
